import React, { useState, useEffect, useCallback } from 'react';

const SlideShow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const banners = [
    "./bannerr.jpg",
    "./bannerr.jpg", 
    "./bannerr.jpg"
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  }, [banners.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  // Auto-slide
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <div className="relative w-full max-w-6xl mx-auto overflow-hidden bg-gray-50 group">
      {/* Images */}
      {banners.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Slide ${index + 1}`}
          className="w-full h-auto block"
          style={{
            display: index === currentIndex ? 'block' : 'none'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://via.placeholder.com/1200x400/F3F4F6/9CA3AF?text=Banner+" + (index + 1);
          }}
        />
      ))}

      {/* Navigation Buttons */}
      <button 
        onClick={prevSlide}
        className="absolute top-1/2 -translate-y-1/2 left-4 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white border border-gray-200 text-gray-600 text-2xl md:text-3xl font-light cursor-pointer hover:bg-blue-50 hover:text-blue-600 hover:border-blue-600 hover:scale-110 opacity-0 group-hover:opacity-100 transition-opacity shadow-md z-10"
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button 
        onClick={nextSlide}
        className="absolute top-1/2 -translate-y-1/2 right-4 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white border border-gray-200 text-gray-600 text-2xl md:text-3xl font-light cursor-pointer hover:bg-blue-50 hover:text-blue-600 hover:border-blue-600 hover:scale-110 opacity-0 group-hover:opacity-100 transition-opacity shadow-md z-10"
        aria-label="Next slide"
      >
        ›
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 px-4 py-2 bg-white/90 border border-gray-100 shadow-sm z-10">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-2 transition-all duration-300 ${
              index === currentIndex 
                ? 'w-6 bg-blue-600' 
                : 'w-2 bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Bottom Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/5 to-transparent pointer-events-none" />
    </div>
  );
};

export default SlideShow;